'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./column.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Column(_ref) {
  var children = _ref.children,
      className = _ref.className,
      flex = _ref.flex,
      smStart = _ref.smStart,
      mStart = _ref.mStart,
      lgStart = _ref.lgStart,
      smSpan = _ref.smSpan,
      mSpan = _ref.mSpan,
      lgSpan = _ref.lgSpan,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ['children', 'className', 'flex', 'smStart', 'mStart', 'lgStart', 'smSpan', 'mSpan', 'lgSpan', 'style']);

  var classes = (0, _classnames2.default)(smSpan && 'grid-column--sm-span-' + smSpan, mSpan && 'grid-column--m-span-' + mSpan, lgSpan && 'grid-column--lg-span-' + lgSpan, smStart && 'grid-column--sm-start-' + smStart, mStart && 'grid-column--m-start-' + mStart, lgStart && 'grid-column--lg-start-' + lgStart, flex && 'grid-column--flex', !!window.MSInputMethodContext && !!document.documentMode && 'grid-column--ie11', className);

  return _react2.default.createElement(
    'div',
    _extends({ className: classes, style: style }, props),
    children
  );
}

Column.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  flex: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  smStart: _propTypes2.default.oneOf(['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11']),
  mStart: _propTypes2.default.oneOf(['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11']),
  lgStart: _propTypes2.default.oneOf(['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11']),
  smSpan: _propTypes2.default.oneOf(['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']),
  mSpan: _propTypes2.default.oneOf(['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']),
  lgSpan: _propTypes2.default.oneOf(['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'])
};

exports.default = Column;